import { useEffect, useState } from "react";
import { _DocumentFactory, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_LG, MODAL_SM, MODAL_XL } from "../../../../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { Modal } from "../../../../../../theme/Component/Modal";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { YearSelector } from "../../../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../../../contract/select/SelectMonths";
import { AccountEditor } from "../../../../../../editor/AccountEditor";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { ErrorList } from "../../../../../../theme/Component/ErrorList";
import { DocumentViewer } from "../../../../../../theme/Component/DocumentViewer";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { SelectProject } from "../../../../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import usePaginator from "../../../../../../theme/Component/usePaginator";
import { ParentDocument } from "./ParentDocument";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { UBLPayment } from "../../../../../../contabilidad/CatalogoDocumentosUBL/UBLPayment/UBLPayment";

interface Props {
    IDProject?: any;
    onChange?: any;
    label?: string;
    isMenu?: boolean;
    onChangeProyect?: Function;
}

interface FormProps {
    Year: number;
    Mnemonic: string;
    Month?: number;
    IDAccount?: number;
    Consecutive?: number;
    AccountIDSte?: string;
    IDProject?: number
}

export const UBLInvoiceFactory = ({ onChange, label, isMenu, onChangeProyect, IDProject }: Props) => {

    const { instance, lista, bean, setBean, setLista } = useDataBean(_DocumentFactory);
    const doc = useDataBean(_DocumentFactory)
    const [renderValue, setRenderValue] = useState<string>("");
    const [form, setForm] = useState<FormProps>({
        Mnemonic: "UBLINV",
        Year: _single.getCurrenYear(),
        Month: _single.getCurrentMonth(),
    })
    const paginador = usePaginator();
    const [modalfac, setModalfac] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const modal = useModal("Seleccione una Factura Pagada a Terceros por Proyectos", MODAL_LG);
    const modalDoc = useModal("Documento Contable", MODAL_XL);
    const modalAsociate = useModal("Asociar Documento Contable", MODAL_XL);
    const modalDisasociate = useModal("Liberar Documento de Cruce", MODAL_SM);

    useEffect(() => {
        if (form.Year && form.Mnemonic && form.Month) {
            getLista();
        } else {
            toast.error("Campos Obligatorios: Vigencia y Mes")
        }
    }, [paginador.page])
    // 🔹 Si IDProject viene con valor, se guarda automáticamente en el form
    useEffect(() => {
        if (IDProject) {
            setForm((prev) => ({ ...prev, IDProject: IDProject }));
        }
    }, [IDProject]);
    const getLista = () => {
        const projectId = IDProject ?? form.IDProject; // ✅ usa el prop si existe, sino el del formulario
        instance.getDocumentHeaderByMnemonicAndProject(form.Year, form.Month, form.IDAccount, form.Mnemonic, form.Consecutive, null, projectId, paginador.page, 15).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                if (resp.List) {
                    resp.List.forEach(element => {
                        const document = element.DataBeanProperties;
                        document.RenderDocumento = `${document.Consecutive ? `${document.Mnemonic} - ${document.Consecutive}` : "N/A"}`;
                        document.RenderFactura = `${document.ParentConsecutive ? `${document.ParentMnemonic} - ${document.ParentConsecutive}` : "N/A"}`;
                    });
                }
                setLista(resp.List);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'Documento Remisión', property: 'RenderDocumento', visible: true },
        { title: 'Identificación', property: 'AccountNit', visible: true },
        { title: 'Tercero', property: 'AccountName', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Estado', property: 'DocumentStateName', visible: true },
        { title: 'Proyecto', property: 'ProjectName', visible: true },
        { title: 'Factura', property: 'RenderFactura', visible: true },
        { title: 'Fecha Factura', property: 'ParentDate', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-eye-line', visible: bean.IDDocument, evento: () => { getDocument(bean.IDDocument, bean.DocumentDate) } },
            { titulo: 'Ver Documento de Cruce', icono: 'ri-eye-line', visible: bean.ParentIDDocument, evento: () => { getDocument(bean.ParentIDDocument, bean.ParentDate) } },
            { titulo: 'Ver pagos de Factura', icono: 'ri-list-ordered', visible: true, evento: () => { setModalfac({ ...modalfac, "view": true, "name": `Ver pagos de Factura` }) } },
            { titulo: 'Asociar Documento de Cruce', icono: 'ri-add-line', visible: true, evento: () => { modalAsociate.open(); setSelectDoc({}) } },
            { titulo: 'Liberar Documento de Cruce', icono: 'ri-subtract-line', visible: bean.ParentIDDocument, evento: () => { modalDisasociate.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const getDocument = (idDocument: number, docDate: any) => {
        instance.getAccountantDocumentByLocation(idDocument, docDate).then(
            (resp) => {
                doc.setLista(resp.DocumentURL)
                modalDoc.open()
                setMsgList(resp.MsgList);
            }
        ).catch(err => { toast.error(err) })
    }

    const selectItem = () => {
        if (bean.IDDocument) {
            setRenderValue(`${bean.RenderDocumento}`)
            modal.close();
            onChange?.(bean)
        } else {
            toast.error("Orden no valida")
        }
    }

    const [msgList, setMsgList] = useState<any>([]);
    const [selectDoc, setSelectDoc] = useState<any>({});

    const asingParentDocument = () => {
        instance.setParentDocument(bean.IDDocument, bean.DocumentDate, selectDoc.IDDocument, selectDoc.Since).then(
            (resp) => {
                getLista();
                modalAsociate.close();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const disasociate = () => {
        instance.releaseParentDocument(bean.IDDocument, bean.DocumentDate).then(
            (resp) => {
                getLista();
                modalDisasociate.close();
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const returnComponente = () => {
        return (
            <div className="row">
                <div className="col-md-6">
                    <YearSelector onChange={(e) => { setForm({ ...form, Year: e }) }} value={form.Year} tittle="Vigencia" />
                </div>
                <div className="col-md-6">
                    <SelectMonths idSelector={form.Month} onChange={(e) => { setForm({ ...form, Month: e }) }} label="Mes" />
                </div>
                <div className="col-md-6">
                    <AccountEditor idAccount={form.IDAccount} label="Tercero" onChange={(e) => { setForm({ ...form, IDAccount: e.IDAccount }) }} />
                </div>
                <div className="col-md-6">
                    <label>Consecutivo</label>
                    <input type="number" className="form-control" value={form.Consecutive} onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : null;
                        setForm({ ...form, Consecutive: value })
                    }} />
                </div>
                <div className="col-md-6">
                    {/* <SelectProject label="Proyecto" idSelector={form.IDProject} onChange={(e: any) => {
                        setForm({ ...form, IDProject: e?.IDProject });
                        onChangeProyect?.(e);
                    }} returnType="Object" /> */}
                    <SelectProject
                        label="Proyecto"
                        idSelector={form.IDProject}
                        disabled={!!IDProject} // 🔹 opcional: desactiva el selector si viene por props
                        onChange={(e: any) => {
                            // Solo actualiza si el proyecto no viene como prop
                            if (!IDProject) {
                                setForm({ ...form, IDProject: e?.IDProject });
                            }
                        }}
                        returnType="Object"
                    />
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton eventClick={() => {
                        if (form.Year && form.Mnemonic) {
                            getLista();
                        }
                    }} icon="ri-search-line" children={`Buscar`} />
                </div>
                <div className="col-md-12">
                    <BasicTable
                        listButtons={listaBotones()}
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                    />
                </div>

                <Modal modal={modalfac} updateModal={setModalfac} >
                    <>
                        <UBLPayment idUBLInvoice={bean.IDUBLInvoice} issueDate={bean.IssueDate} />
                    </>
                </Modal>
                <div className="col-md-12">
                    <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal} >
                        <div className="row">
                            <div className="col">
                                {msgList.length > 0 &&
                                    <ErrorList lista={msgList} />
                                }
                                {msgList.length === 0 && lista.length > 0 &&
                                    <DocumentViewer key={doc.lista} list={doc.lista} />
                                }
                            </div>
                        </div>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <ModalConfirm eventModal={disasociate} modal={modalDisasociate.modal} updateModal={modalDisasociate.setModal} >
                        ¿Desea liberar el Documento Asociado?
                    </ModalConfirm>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalAsociate.modal} updateModal={modalAsociate.setModal} eventModal={() => {
                        if (selectDoc.IDDocument) {
                            asingParentDocument()
                        } else {
                            toast.error("Documento no Valido")
                        }
                    }} >
                        <ParentDocument onChange={(e) => { setSelectDoc(e) }} />
                    </Modal>
                </div>
            </div>
        )
    }


    return isMenu ? (
        <BasicPage children={returnComponente()} titulo="Facturas Pagadas a Terceros por Proyecto" />
    ) : (
        <>
            <label>{label ? label : 'Factura Pagada a terceros por proyecto'}</label>
            <input
                type="text"
                className="form-control"
                placeholder="Buscar..."
                value={renderValue}
                onClick={() => { modal.open() }}
            />

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { selectItem() }}>
                {returnComponente()}
            </Modal>
        </>
    )

}